import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { ApiService } from './apiservice';
import { AdminDistrictOrder } from '../app/interfaces/AdminDistrictOrder';
import { AdminDateModifiedOrder } from '../app/interfaces/AdminDateModifiedOrder';
import { AdminNameOrder } from '../app/interfaces/AdminNameOrder';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  url: string;
  urlUserFilter: string;
  apiToken: string = "";
  userId: string = "";
  userObject: any;

  constructor(private http: HttpClient, private apiService: ApiService) {
    this.url = environment.apiConfig.apiPath;
    this.urlUserFilter = environment.apiConfig.uri + environment.apiConfig.userIdFilter;

  }

  public getUser() {
    return this.apiService.getUser();
  }

  getOrderUpdateDate(groupId: any): Observable<AdminDateModifiedOrder[]> {
    return this.apiService.get(this.url + `api/Admin/GetOrderUpdateDate/${groupId}`);
  }

  getAllOrdersByModifiedName(groupId: any): Observable<any> {
    return this.apiService.get(this.url + `api/Admin/GetAllOrdersByModifiedName/${groupId}`);
  }

  getOrderByModifiedName(name: any, groupId: any): Observable<any> {
    return this.apiService.get(this.url + `api/Admin/GetOrderByModifiedName/${name}/${groupId}`);
  }

  getOrderBySubmitter(name: any, groupId: any): Observable<any> {
    return this.apiService.get(this.url + `api/Admin/GetOrderBySubmitter/${name}/${groupId}`);
  }  

  getAdminDistrictOrders(payload: any) {
    return this.apiService.post(this.url + "api/Admin/GetAdminOrderByDistrict", payload);
  }

  getAdminDateModifiedOrders(payload: any) {
    return this.apiService.post(this.url + "api/Admin/GetOrderByDateModified", payload);
  }

  getOrderDetailsByName(payload: any) {
    return this.apiService.post(this.url + "api/Admin/GetOrderDetailsByName", payload);
  }

  getAdminDistricts(empId: any): Observable<any> {
    return this.apiService.get(this.url + `api/Admin/GetAdminDistricts/${empId}`);
  }
}
